<i18n>{
	"no": {
		"ordersOverview" : "Oppdrag | Oppdrag ({n}) | Oppdrag ({n})",
		"originalMessage": "JSON"
	},
	"en":{
		"ordersOverview" : "Orders| Orders({n}) | Orders({n})",
		"originalMessage": "JSON"
	}

}
</i18n>
<template>
	<div style="padding:0.3em;">
		<div class="navigation">
			<t-tab-list :items="tabs" :selected.sync="selectedTab">
				<template v-slot="slotProps">
					<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
						{{$tc(slotProps.item.name, getOrdersLength())}}
					</t-tab>
				</template>
			</t-tab-list>
		</div>
		<t-pane class="settings-content">
			<component
				:is="selectedTab.id"
				:ref="selectedTab.ref"
				:ordersAndErrors="ordersAndErrors"
			/>
		</t-pane>

	</div>
</template>

<script>

import OrdersOverview from './OrdersOverview.vue';
import OriginalMessage from './OriginalMessage.vue';
export default {
	components: { OrdersOverview, OriginalMessage },
	props: {
		ordersAndErrors: Object,
	},
	data() {
		return {
			tabs: [
				{
					id: 'OrdersOverview',
					key: 'ordersOverview',
					ref: 'ordersOverview',
					name: 'ordersOverview',
				},
				{
					id: 'OriginalMessage',
					key: 'originalMessage',
					ref: 'originalMessage',
					name: 'originalMessage',
				}
			],
			selectedTab: { id:'OrdersOverview', key: 'ordersOverview', ref: 'ordersOverview' },
		};
	},
	methods: {
		getOrdersLength() {
			let array = [];

			for (let id of this.ordersAndErrors.orderIds) {
				if (array.indexOf(id) > -1)
					continue;
				array.push(id);
			}

			return array.length;
		}
	}
};
</script>

<style lang="scss" scoped>
.details-grid{
	display: grid;
	grid-template-columns: 240px 1100px;
}
</style>